<template>
  <!-- "Built with love by Prefetch": the attribution in the generator's left
       panel, the content pages' footer and the brand hub's pinned search. One
       event name for all three, so the totals add up; `location` says which
       surface was clicked and `page` where from — and the page also rides
       along in the link's `utm_term`, so Prefetch sees it too. -->
  <p class="flex items-center gap-x-1 text-sm text-gray-500">
    Built with love by
    <a
      class="group relative isolate flex items-center rounded-lg p-0.5"
      :href="apiUrl('footer_logo', route.path)"
      target="_blank"
      rel="noopener"
      @click="onClick"
    >
      <span
        class="absolute inset-0 -z-10 scale-75 rounded-lg bg-white/5 opacity-0 transition group-hover:scale-100 group-hover:opacity-100"
        aria-hidden="true"
      ></span>
      <!-- The wordmark sits in the lower part of the artwork (the spark rises
           above it), so the uneven margins line its baseline up with the text. -->
      <img :src="prefetchLogo" alt="Prefetch" width="88" height="19" class="mx-1.5 mb-3 mt-1.5" />
    </a>
  </p>
</template>

<script setup>
import { trackEvent } from '~/composables/analytics'
import prefetchLogo from '~/assets/img/prefetch-logo.svg'
import { apiUrl } from '~/utils/site'

const props = defineProps({
  location: { type: String, default: 'footer' },
})

const route = useRoute()

const onClick = () => {
  try {
    trackEvent('prefetch.io Footer Logo Clicked', { page: route.path, location: props.location })
  } catch {}
}
</script>
